const init = (select = null, data = null) => {
	let options = {
	    theme: 'bootstrap4',
	    width: '100%'
	};

	if(data){
		options = {
			...options,
		  	data: data
		}
	}

	if(!select){
		select = $('.select2');
	}

	if(select.length){
		select.each(function(){
			let newOption = {
				...options
			};
						
			if($(this).data('tags')){				
				newOption = {
					...options,
					tags: true
				};
			}
			
			$(this).select2(options);			
		});

		// open select2 when focusing on it
		$(document).on('focus', '.select2.select2-container', function (e) {
			// only open on original attempt - close focus event should not fire open
			if (e.originalEvent && $(this).find(".select2-selection--single").length > 0) {
				$(this).siblings('select').select2('open');
			} 
		});
	}
}

export default init;